// extracted by mini-css-extract-plugin
module.exports = {"title":"Areas_title__2f-Yv","area":"Areas_area__3QdxF","message":"Areas_message__byhrv"};